export default __webpack_public_path__ + "static/media/header-graphics.e7f5437c.png";